import React from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../layouts/user';
import useProductSchema from './hooks/useProductSchema';
import { SchemaLoadingScreen, ProductNotFoundScreen } from './ProductPageStates';
import GenericTradeEntry from './GenericTradeEntry';
import './productEngine.css';

/**
 * TradeEntryPage: Route component for
 * /portal/invest/trade/:productType/:sourceCurrency/:targetCurrency.
 */
const TradeEntryPage = () => {
  const { productType, sourceCurrency, targetCurrency } = useParams();
  const { schema, isLoading } = useProductSchema(productType);

  if (isLoading) {
    return <SchemaLoadingScreen />;
  }

  if (!schema) {
    return <ProductNotFoundScreen productType={productType} />;
  }

  return (
    <Layout menu="plans">
      <div className="product-engine-ui">
        <GenericTradeEntry
          schema={schema}
          sourceCurrency={sourceCurrency}
          targetCurrency={targetCurrency}
        />
      </div>
    </Layout>
  );
};

export default TradeEntryPage;
